<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="chapter-title">
      Форма 5. Учетный лист журнала технического надзора
    </div>
    <n-divide v-if="$app.auth.can('projects_tech', project.id)" class="table-tools">
      <div></div>
      <n-link :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">Дата</td>
          <td rowspan="2">Выявленные отступления от проекта, технологии производства (качества) работ и нарушения требований и правил государственных нормативов в области строительства, с указанием об их устранении, требуемые сроки их устранения, факты замены строительных материалов, изделии, конструкции, оборудовании, не предусмотренных в утвержденной проектно-сметной документации</td>
          <td rowspan="2">Фамилия, инициалы представителя технического надзора, внесшего запись, дата внесения записи</td>
          <td colspan="2">Фамилия, инициалы (при его наличии) и должность лица ознакомившегося с записью, дата ознакомления</td>
          <td colspan="3">Отметки о выполнении указаний (фамилия, инициалы, должность, дата)</td>
          <td rowspan="2">Статус</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>Представитель подрядчика (субподрядчика)</td>
          <td>Представитель заказчика</td>
          <td>Представитель подрядчика (субподрядчика)</td>
          <td>Представитель заказчика</td>
          <td>Представитель технического надзора</td>
        </tr>
      </template>
      <template #publishedAt="{item}">
        {{ $app.date.format(item.publishedAt) }}
      </template>
      <template #author="{item}">
        <c-journal-sign :sign="getSign(item, 'author')" />
      </template>
      <template #client="{item}">
        <c-journal-sign :sign="getSign(item, 'client')" />
      </template>
      <template #executor="{item}">
        <c-journal-sign :sign="getSign(item, 'executor')" />
      </template>
      <template #authorDone="{item}">
        <c-journal-sign :sign="getSign(item, 'authorDone')" />
      </template>
      <template #clientDone="{item}">
        <c-journal-sign :sign="getSign(item, 'clientDone')" />
      </template>
      <template #executorDone="{item}">
        <c-journal-sign :sign="getSign(item, 'executorDone')" />
      </template>
      <template #status="{item}">
        {{ utils.status(item.status) }}
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter5',
  components: { CJournalSign, ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    columns() {
      return [
        { name: 'publishedAt', title: '', },
        { name: 'problem', title: '', },
        { name: 'author', title: '', },
        { name: 'executor', title: '', },
        { name: 'client', title: '', },
        { name: 'executorDone', title: '', },
        { name: 'clientDone', title: '', },
        { name: 'authorDone', title: '', },
        { name: 'status', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
